import { CircularProgress } from "@mui/material";
import { Form, Formik, FormikHelpers } from "formik";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { TestSeriesFormValues } from "src/models/TestSeries.model";
import { useEditTestSeriesMutation, useGetTestSeriesByIdQuery } from "src/services/TestSeriesServices";
import { showToast } from "src/utils/showToaster";
import { array, object, string } from "yup";
import TestSeriesForm from "../Layout/TestSeriesForm";


const EditTestSeriesFormWrapper = () => {

  const { id = "" } = useParams();
  const navigate = useNavigate()
  const [testSeriesData, setTestQuestion] = useState<any>({});

  const [editTestQuestion] = useEditTestSeriesMutation();
  const { data, isLoading, isFetching } = useGetTestSeriesByIdQuery({
    id: id,
  });

  useEffect(() => {
    if (!isLoading && !isFetching) {
      setTestQuestion(data?.data);
    }
  }, [data, isLoading, isFetching]);

  const initialValues: TestSeriesFormValues = {
    testImage: testSeriesData?.testImage || '',
    testDescription: testSeriesData?.testDescription || '',
    questionTag: testSeriesData?.testTag || [],
    questionTechnologyId: testSeriesData?.testTechnologyDetails?.map((el: any) => {
      return {
        label: el?.questionTechnology || '',
        value: el?._id || ''
      }
    }) || [],
    questionTitle: testSeriesData?.testTitle || '',
    questionOptions: testSeriesData?.questionDetails?.map((question: any) => question) || [],
    price: testSeriesData?.price || '',
    oldPrice: testSeriesData?.mrp || '',
    passingPercent: testSeriesData?.passingPercent || '',
    testTime: testSeriesData?.testTime || '',
  };

  // Validation Schema
  const validationSchema = object().shape({
    questionTag: array().min(1, "At least one tag is required"),
    questionTechnologyId: array().min(1, "At least one technology is required"),
    questionTitle: string().required("Title is required"),
    testDescription: string().required("Description is required"),
    testImage: string().required("Image is required"),
    questionOptions: array().min(1, "At least one qustion is select"),
    passingPercent: string().required("Passing percent is required"),
    testTime: string().required("Test Time is required"),
    price: string().required("offer price is required")
      .test(
        'is-greater-or-equal',
        'Offer Price should not be greater than MRP',
        function (value: any) {
          const { oldPrice } = this.parent;
          return value <= Number(oldPrice);
        }
      ),
  });

  // Handle Submit
  const handleSubmit = (
    values: TestSeriesFormValues,
    { setSubmitting, resetForm }: FormikHelpers<TestSeriesFormValues>
  ) => {

    const formatedValue = {

      testTag: values?.questionTag,
      testTechnologyId: values?.questionTechnologyId?.map((technology: any) => technology?.value),
      testTitle: values?.questionTitle,
      questionId: values?.questionOptions?.map((question: any) => question?._id) || [],
      testImage: values?.testImage,
      testDescription: values?.testDescription,
      price: values?.price,
      mrp: values?.oldPrice,
      testTime: values?.testTime,
    };
    editTestQuestion({ body: formatedValue, id: id }).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          navigate('/test-module/test-series')

        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {(formikProps) => (
        <Form className="h-full overflow-hidden contents">
          {(isLoading || isFetching) && (
            <div className="absolute w-[100%] h-[100%] flex justify-center items-center z-10 bg-slate-100 opacity-50">
              <CircularProgress />
            </div>
          )}
          <TestSeriesForm
            formikProps={formikProps}
            formType="Edit"
          />
        </Form>
      )}
    </Formik>
  );
};

export default EditTestSeriesFormWrapper;
